import resolve from '../../../../../modules/api/resolve';
import { apiPost, apiStore, generateFormData } from '../../../../../modules/apiHelper';
import {
  invalideDate, isStaleData, now, objectIsValid,
} from '../../../../../modules/dataHelper';

export default {
  async createCompanyProgram(context, formData) {
    const response = await resolve(apiPost('create_prog', formData, 79)).then(async (data) => {
      if (!data) return false;

      return true;
    });

    return response;
  },

  async getCompanyPrograms(context, [companyid, refresh = false]) {
    if (!companyid) return false;
    const CACHE_KEY = `company/${companyid}/programs`;

    const program = await apiStore.getItem(CACHE_KEY) || [invalideDate, {}];

    if (!refresh && !isStaleData(program[0]) && objectIsValid(program[1])) return program[1];

    if (refresh) {
      apiStore.removeItem(CACHE_KEY);
    }

    const formData = generateFormData({ companyid });
    const response = await resolve(apiPost('prog_list', formData, 79)).then(async (data) => {
      if (!data) return false;

      return data.prog_list;
    });

    if (!response) return false;

    apiStore.setItem(CACHE_KEY, [now(), response]);

    return response;
  },

  async getProgram(context, [programId, refresh = false]) {
    if (!programId) return false;
    const CACHE_KEY = `program/${programId}`;

    const program = await apiStore.getItem(CACHE_KEY) || [invalideDate, {}];

    if (!refresh && !isStaleData(program[0]) && objectIsValid(program[1])) return program[1];

    if (refresh) {
      await apiStore.removeItem(CACHE_KEY);
    }

    const formData = generateFormData({ progid: programId });
    const response = await resolve(apiPost('prog', formData, 79)).then(async (data) => {
      if (!data) return false;

      return data.prog[0];
    });

    if (!response) return false;

    apiStore.setItem(CACHE_KEY, [now(), response]);

    return response;
  },

  async updateActiveProgram(context) {
    const { activeProgram } = context.rootState.CompanyPrograms.ProgramContext;

    if (!activeProgram) {
      console.error('error::updateActiveProgram');
      return;
    }

    const newActiveProgram = await context.dispatch('getProgram', [activeProgram.id, true]);

    if (newActiveProgram?.id) {
      context.commit('setActiveProgram', newActiveProgram);
    }
  },

  async deleteCompanyProgram(context, data) {
    const response = await resolve(apiPost('del_prog', generateFormData(data), 79)).then(async (res) => {
      if (!res) return false;

      return true;
    });

    if (response) {
      await apiStore.removeItem(`program/${data.progid}`);
    }

    return response;
  },

  async activateCompanyProgram(context, data) {
    const response = await resolve(apiPost('act_prog', generateFormData(data), 79)).then(async (res) => {
      if (!res) return false;

      return true;
    });

    return response;
  },

  async deactivateCompanyProgram(context, data) {
    const response = await resolve(apiPost('dev_prog', generateFormData(data), 79)).then(async (res) => {
      if (!res) return false;

      return true;
    });

    return response;
  },

  async archiveCompanyProgram(context, data) {
    const response = await resolve(apiPost('archieve_prog', generateFormData(data), 79)).then(async (res) => {
      if (!res) return false;

      return true;
    });

    return response;
  },

  async uploadProgramAdminGuide(context, formData) {
    const response = await resolve(apiPost('create_prog_mail_guide', formData, 79)).then(async (res) => {
      if (!res) return false;

      return true;
    });

    return response;
  },

  async editProgramName(context, data) {
    const response = await resolve(apiPost('edit_prog_name', generateFormData(data), 79)).then(async (res) => {
      if (!res) return false;

      return true;
    });

    return response;
  },

  async editProgramDescription(context, data) {
    const response = await resolve(apiPost('edit_prog_desc', generateFormData(data), 79)).then(async (res) => {
      if (!res) return false;

      return true;
    });

    return response;
  },

  async editProgramLogo(context, formData) {
    const response = await resolve(apiPost('edit_prog_logo', formData, 79)).then(async (res) => {
      if (!res) return false;

      return true;
    });

    return response;
  },

  async editProgramColors(context, data) {
    const response = await resolve(apiPost('edit_prog_color', generateFormData(data), 79)).then(async (res) => {
      if (!res) return false;

      return true;
    });

    return response;
  },

  async editProgramDateStart(context, data) {
    const response = await resolve(apiPost('edit_prog_start', generateFormData(data), 79)).then(async (res) => {
      if (!res) return false;

      return true;
    });

    return response;
  },

  async editProgramDateEnd(context, data) {
    const response = await resolve(apiPost('edit_prog_end', generateFormData(data), 79)).then(async (res) => {
      if (!res) return false;

      return true;
    });

    return response;
  },
};
